import axios from "@/http";
import { handleGetRequestParams } from '@/common/js/util'

class LaborCost {
  /* 人工成本列表 */
  static getLaborCostList(options) {
    let url = `/oa/api/employee/cost/import/page?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 录入 */
  static postEntryLaborCost(data) {
    let url = `/oa/api/employee/cost/import/update`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 人工成本导入详情 */
  static getLaborCostDetails(options) {
    let url = `/oa/api/employee/cost/import/get?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 人工成本导出 */
  static getExportLaborCostExcel(options) {
    let url = `/oa/api/download/employee/cost/list?`;
    url += handleGetRequestParams(options)
    return axios.get(url, { responseType: "blob" }).then(res => {
      return Promise.resolve(res);
    });
  }
}

export default LaborCost;